export const legacyGinWatchersIssueRoute = {
	name: 'legacy-gin-watchers-issue',
	path: '/secure/ManageWatchers!default.jspa',
};
